import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';

export function active_clients(limit, offset) {
  return fetch(Helpers.endpoint("/admin_active_clients"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token
    })
  }).then((response) => response.json())

}
